import React from 'react';
import { Container } from 'reactstrap';

import CustomCalendar from '../../../components/FullCalendar';
import SimpleHeader from '../../../components/Headers/SimpleHeader';

const Calendario: React.FC = ({ props }: any) => {
  return (
    <>
      <SimpleHeader name="Calendário" parentName="Vendas" {...props} />
      <div className="w-100" >
        <CustomCalendar />
      </div>
    </>
  );
};

export default Calendario;
